/* eslint-disable indent */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/camelcase */
import {
  Avatar,
  Grid,
  makeStyles,
  Tooltip,
  Typography,
} from '@material-ui/core';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useParams } from 'react-router';
import CachedIcon from '@material-ui/icons/Cached';
import BlockIcon from '@material-ui/icons/Block';
import EditIcon from '@material-ui/icons/Edit';
import Button from 'components/Button';
import moment from 'moment';
import { Formik } from 'formik';
import i18n from 'i18n';
import { CompanyFields } from 'modules/companies/interfaces';
import { clearFieldsErrors } from 'modules/errors/actions';
import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import {
  GetOperatorFields,
  OperatorPermissionRoles,
} from 'modules/operators/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import GenericForm from 'skyone-lib/lib/GenericForm';
import ApplicationState from 'store/interfaces';
import palette from 'theme/palette';
import { useFilePicker } from 'use-file-picker';
import { applyI18n, regexExp } from 'utils/helpers';
import SecurityIcon from '@material-ui/icons/Security';
import PhonelinkLockIcon from '@material-ui/icons/PhonelinkLock';
import {
  resetMFAToOperatorRequest,
  toggleBlockOperatorRequest,
  updateMFARequest,
  setPendingPermissionsRequest,
} from 'modules/operators/actions';
import clsx from 'clsx';
import Loading from 'components/Loading';
import Permission from 'components/ValidPermission';

import SelectCompany, { CompanyFieldsProps } from 'components/SelectCompany';
import CompanyList from 'components/SelectCompany/companyList';
import { PermissionsData } from 'modules/authenticate/interfaces';
import screenFields from './formFields';
import { initialEdit } from './initialValues';
import ResetModal from './PasswordResetModal';
import validationSchema from './schema';
import styles from './styles';
import OperatorRolesAvailable from './operatorRolesAvailable';

const useStyles = makeStyles(styles);

const initialQuery = {
  offset: 0,
  limit: 800,
  search: '',
};

interface FormProps {
  checks: OperatorPermissionRoles[];
  companyList: CompanyFields[];
  companyLoading: boolean;
  fieldsErrors: any;
  initialValues: GetOperatorFields;
  isEdit?: boolean;
  isLoading: boolean;
  modalVersion?: boolean;
  operator_uuid?: string;
  useCompanyList?: boolean;
  permissions?: PermissionsData;
  clearFieldsErrors: () => void;
  modalClose: () => void;
  modalOpen: (props: ModalFields) => void;
  onCancel: () => void;
  onSubmit: (values: any) => void;
  resetMFAToOperatorRequest: ({ operator_uuid, query }) => void;
  setPendingPermissionsRequest: (props) => void;
  toggleBlockOperatorRequest: (props: {
    operator_uuid: string;
    blocked: boolean;
    query?: typeof initialQuery;
  }) => void;
  updateMFARequest: ({ operatorUuid, mfaChange, isForm }) => void;
}

const FormOperator = ({
  checks,
  companyList,
  companyLoading,
  fieldsErrors,
  initialValues,
  isEdit,
  isLoading,
  modalVersion,
  operator_uuid,
  useCompanyList,
  permissions,
  clearFieldsErrors,
  modalClose,
  modalOpen,
  onCancel,
  onSubmit,
  resetMFAToOperatorRequest,
  setPendingPermissionsRequest,
  toggleBlockOperatorRequest,
  updateMFARequest,
}: FormProps) => {
  const classes = useStyles();
  const [query] = React.useState(initialQuery);
  const { id } = useParams<{ id: string }>();
  const [
    companyFields,
    setCompanyFields,
  ] = React.useState<CompanyFieldsProps | null>({
    company_name: initialValues?.company?.company_name,
    company_uuid: initialValues?.company?.company_uuid,
  });
  const [formValues, setFormValues] = React.useState<GetOperatorFields>(
    initialEdit
  );
  const [roleOperator, setRoleOperator] = React.useState<any>(formValues?.role);
  const [openFileSelector, { filesContent }] = useFilePicker({
    readAs: 'DataURL',
    accept: 'image/*',
    multiple: false,
    maxFileSize: 10,
  });
  const [openCompanySelector, setOpenCompanySelector] = React.useState(true);
  const handleResetPassword = () => {
    modalOpen({
      title: i18n.t('RESET_PASSWORD_OPERATOR_KEY'),
      content: <ResetModal operator={formValues} onCancel={modalClose} />,
      noBorder: true,
    });
  };

  React.useEffect(() => {
    setRoleOperator(formValues?.role);
    setPendingPermissionsRequest(formValues?.permission_roles || []);
    setCompanyFields({
      company_name: formValues?.company?.company_name,
      company_uuid: formValues?.company?.company_uuid,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValues]);

  const formatPhoneNumber = (phoneNumber: string) => {
    if (!phoneNumber) return '';

    return !regexExp.numbersOnly.test(phoneNumber)
      ? `55${phoneNumber.replace(/\D/g, '')}`
      : phoneNumber;
  };

  React.useEffect((): void => {
    screenFields.forEach(item => {
      if (item?.stateKey === 'email') {
        item.disabled = isEdit;
      }

      return item;
    });
  }, [companyList, companyLoading, isEdit]);

  const changeInitialValues = React.useCallback(() => {
    if (!initialValues) return initialEdit;
    return {
      ...initialValues,
      company_uuid: initialValues?.company?.company_uuid,
    };
  }, [initialValues]);

  React.useEffect(() => {
    setFormValues(changeInitialValues());
  }, [changeInitialValues]);

  const handleToggleBlockOperator = (operator: GetOperatorFields) => {
    const { operator_uuid, blocked, first_name, last_name } = operator;
    modalOpen({
      title: i18n.t(
        blocked
          ? 'OPERATORS_PAGE.UNBLOCK_OPERATOR_TITLE_KEY'
          : 'OPERATORS_PAGE.BLOCK_OPERATOR_TITLE_KEY'
      ),
      content: i18n.t(
        blocked
          ? 'OPERATORS_PAGE.UNBLOCK_OPERATOR_DESCRIPTION_KEY'
          : 'OPERATORS_PAGE.BLOCK_OPERATOR_DESCRIPTION_KEY',
        {
          name: `${first_name} ${last_name}`,
        }
      ),
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              toggleBlockOperatorRequest({
                operator_uuid,
                blocked: !blocked,
                query,
              });
              modalClose();
            }}
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  const resetMFAOperator = (operator: GetOperatorFields) => {
    modalOpen({
      title: i18n.t('MFA_RESET_KEY'),
      content: i18n.t('OPERATORS_PAGE.RESET_MFA_OPERATOR_KEY', {
        firstName: operator?.first_name,
        lastName: operator?.last_name,
      }),
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              resetMFAToOperatorRequest({
                operator_uuid: operator?.operator_uuid,
                query,
              });
              modalClose();
            }}
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };
  const enableMFAOperator = (operator: GetOperatorFields) => {
    modalOpen({
      title: i18n.t('ACTIVATE_MFA_KEY'),
      content: i18n.t('ACTIVATE_MFA_MODAL_MESSAGE_KEY', {
        firstName: operator?.first_name,
        lastName: operator?.last_name,
      }),
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              updateMFARequest({
                operatorUuid: operator?.operator_uuid,
                mfaChange: !operator?.mfa_required,
                isForm: true,
              });
              modalClose();
            }}
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  const dateFormat = (date: string) =>
    moment(new Date(date))
      .local()
      .format(
        i18n.language === 'en'
          ? `MM/DD/YYYY [${i18n.t('OPERATORS_PAGE.TIME_AT_KEY')}] hh:mm`
          : `DD/MM/YYYY [${i18n.t('OPERATORS_PAGE.TIME_AT_KEY')}] HH:mm`
      );

  const handleAdd = () => {
    modalOpen({
      title: i18n.t('GROUPS_PAGE.LIST_GROUPS_TITLE_KEY'),
      subtitle: i18n.t('GROUPS_PAGE.ADD_PARTNERS_SUBTITLE_KEY'),
      content: (
        <OperatorRolesAvailable
          isEdit={isEdit}
          operatorRoleTemplate={roleOperator}
        />
      ),
      maxWidth: 'md',
      fullWidth: true,
      noBorder: true,
      footer: (
        <Grid>
          <Button
            submitButton
            id="confirm-button"
            onClick={() => {
              modalClose();
            }}
          >
            {i18n.t('ADD_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  const onSubmitUpdated = (values: GetOperatorFields) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { permission_roles, ...payload } = values;

    onSubmit({
      ...payload,
      ...(permissions?.list_all_roles && { permission_roles: checks }),
    });
    modalClose();
  };

  return (
    <Grid className={classes.formContainer}>
      <Grid item xs={12} className={classes.topContent}>
        <Button
          id="open-file-selector"
          className={classes.buttonAvatar}
          onClick={openFileSelector}
          disabled
        >
          <Avatar
            variant="rounded"
            src={filesContent[0]?.content}
            className={classes.avatar}
          />
          <EditIcon className={classes.hiddenIcon} />
        </Button>
      </Grid>
      <Grid item xs={12} className={classes.formContainer}>
        <Formik
          initialValues={{
            ...formValues,
            phone: formatPhoneNumber(formValues.phone),
            mobile_phone: formatPhoneNumber(formValues.mobile_phone),
          }}
          validationSchema={validationSchema[isEdit ? 'edit' : 'create']}
          onSubmit={onSubmitUpdated}
          enableReinitialize
        >
          {({ setFieldValue, submitForm, errors, values }) => (
            <>
              <Grid
                item
                container
                spacing={2}
                xs={12}
                className={clsx({
                  [classes.formsGridModal]: modalVersion,
                  [classes.formsGrid]: !modalVersion,
                })}
              >
                <GenericForm
                  fields={{
                    ...values,
                  }}
                  screenFields={applyI18n(
                    screenFields.slice(0, 3),
                    i18n.language
                  )}
                  setFieldValue={(key, value) => {
                    if (['first_name', 'last_name'].includes(key)) {
                      clearFieldsErrors();
                      setFieldValue(key, value);
                      return;
                    }
                    clearFieldsErrors();
                    setFieldValue(key, value);
                  }}
                  errors={fieldsErrors || errors}
                />
                <GenericForm
                  fields={values}
                  screenFields={applyI18n(
                    screenFields.slice(3, 4),
                    i18n.language
                  )}
                  setFieldValue={setFieldValue}
                  errors={errors}
                  overrideClasses={{
                    selectLabel: {
                      fontSize: 12,
                      color: palette.darkGray,
                      fontWeight: 400,
                    },
                  }}
                />
                {id === operator_uuid ? (
                  <GenericForm
                    fields={values}
                    screenFields={applyI18n(
                      screenFields.slice(5, 6),
                      i18n.language
                    )}
                    setFieldValue={setFieldValue}
                    errors={errors}
                  />
                ) : (
                  <GenericForm
                    fields={values}
                    screenFields={applyI18n(
                      screenFields.slice(4, 5),
                      i18n.language
                    )}
                    setFieldValue={(key, value) => {
                      setRoleOperator(value);
                      setFieldValue(key, value);
                    }}
                    errors={errors}
                    overrideClasses={{
                      selectLabel: {
                        fontSize: 12,
                        color: palette.darkGray,
                        fontWeight: 400,
                      },
                    }}
                  />
                )}
                {!useCompanyList ? (
                  <Grid className={classes.selectCompanyGrid}>
                    <SelectCompany
                      companyFields={companyFields}
                      errors={errors}
                      stateKey="company.company_uuid"
                      setCompanyFields={setCompanyFields}
                      setFieldValue={setFieldValue}
                      closeOnSelect
                    />
                  </Grid>
                ) : (
                  <Grid
                    container
                    className={clsx(classes.titleGrid, {
                      [classes.titleGridError]: !!errors?.company?.company_uuid,
                    })}
                  >
                    <Grid container>
                      <Typography className={classes.notFoundText}>{`${i18n.t(
                        'COMPANY_KEY'
                      )}:`}</Typography>
                      <Grid item>
                        <Button
                          id="btn-select-company"
                          onClick={() => {
                            setOpenCompanySelector(!openCompanySelector);
                          }}
                          endIcon={<ExpandMoreIcon />}
                        >
                          {companyFields?.company_name ? (
                            <Typography className={classes.boldText}>
                              {companyFields?.company_name}
                            </Typography>
                          ) : (
                            <Typography className={classes.boldText}>
                              {i18n.t('CHOOSE_COMPANY_KEY')}
                            </Typography>
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                    {openCompanySelector && (
                      <CompanyList
                        companyFields={companyFields}
                        stateKey="company.company_uuid"
                        setCompanyFields={setCompanyFields}
                        setFieldValue={(field, value) => {
                          setFieldValue(field, value);
                          setOpenCompanySelector(false);
                        }}
                      />
                    )}
                  </Grid>
                )}
                {!modalVersion && (
                  <Permission value="list_all_roles">
                    <Tooltip
                      title={
                        !values?.role &&
                        i18n.t('MANAGE_PERMISSIONS_OPERATOR_KEY')
                      }
                      arrow
                      disableHoverListener={!!values?.role}
                    >
                      <Grid item>
                        <Button
                          variant="outlined"
                          disabled={!values?.role}
                          onClick={() => {
                            handleAdd();
                          }}
                          className={classes.buttonManagePermissions}
                          startIcon={
                            <SecurityIcon className={classes.blueIcon} />
                          }
                        >
                          <Typography
                            className={classes.buttonManagePermissionsText}
                          >
                            {i18n.t('OPERATORS_PAGE.MANAGE_PERMISSIONS_KEY')}
                          </Typography>
                        </Button>
                      </Grid>
                    </Tooltip>
                  </Permission>
                )}
                {isEdit && (
                  <>
                    {isLoading ? (
                      <Loading size={24} />
                    ) : (
                      <>
                        {id !== operator_uuid && (
                          <Grid
                            container
                            xs={6}
                            className={classes.creationInfo}
                          >
                            <Grid container>
                              {' '}
                              {values?.created_by_operator &&
                                values?.created_by_operator?.email !== null && (
                                  <Typography className={classes.creationText}>
                                    {`${i18n.t(
                                      'OPERATORS_PAGE.CREATED_BY_KEY'
                                    )}: ${
                                      values?.created_by_operator?.first_name
                                    } ${
                                      values?.created_by_operator?.last_name
                                    } (${values?.created_by_operator?.email})`}
                                  </Typography>
                                )}
                            </Grid>
                            <Grid container>
                              <Typography className={classes.creationText}>
                                {`${i18n.t(
                                  'OPERATORS_PAGE.CREATED_AT_KEY'
                                )}: ${dateFormat(values?.created_date)}`}
                              </Typography>
                              <Typography
                                variant="body1"
                                className={classes.creationText}
                              ></Typography>
                            </Grid>
                          </Grid>
                        )}
                        <Grid container xs={12} className={classes.buttonsInfo}>
                          {id !== operator_uuid && (
                            <>
                              <Grid item className={classes.upperButton}>
                                <Button
                                  className={clsx({
                                    [classes.buttonGreen]:
                                      values?.blocked === true,
                                    [classes.buttonRed]:
                                      values?.blocked === false,
                                  })}
                                  variant="outlined"
                                  onClick={() => {
                                    handleToggleBlockOperator(values);
                                  }}
                                >
                                  {values?.blocked ? (
                                    <CheckCircleOutlineIcon
                                      className={classes.checkIcon}
                                    />
                                  ) : (
                                    <BlockIcon className={classes.blockIcon} />
                                  )}
                                  <Typography
                                    className={clsx({
                                      [classes.buttonTextGreen]:
                                        values?.blocked === true,
                                      [classes.buttonTextRed]:
                                        values?.blocked === false,
                                    })}
                                  >
                                    {i18n.t(
                                      `BLOCK_${String(
                                        values?.blocked
                                      ).toUpperCase()}_OPERATOR_KEY`
                                    )}
                                  </Typography>
                                </Button>
                              </Grid>
                              {values?.mfa_required && (
                                <Grid item className={classes.upperButton}>
                                  <Button
                                    className={classes.buttonBlue}
                                    variant="outlined"
                                    onClick={() => resetMFAOperator(values)}
                                  >
                                    <CachedIcon className={classes.blueIcon} />
                                    <Typography className={classes.resetText}>
                                      {i18n.t('MFA_RESET_KEY')}
                                    </Typography>
                                  </Button>
                                </Grid>
                              )}
                              {values?.role === 'client_operator' &&
                                !values?.mfa_required && (
                                  <Grid item className={classes.upperButton}>
                                    <Button
                                      className={classes.buttonBlue}
                                      variant="outlined"
                                      onClick={() => enableMFAOperator(values)}
                                    >
                                      <PhonelinkLockIcon
                                        className={classes.blueIcon}
                                      />
                                      <Typography className={classes.resetText}>
                                        {i18n.t('ACTIVATE_MFA_KEY')}
                                      </Typography>
                                    </Button>
                                  </Grid>
                                )}
                            </>
                          )}
                          <Grid item className={classes.upperButton}>
                            <Button
                              className={classes.buttonBlue}
                              variant="outlined"
                              id="reset-button"
                              onClick={handleResetPassword}
                            >
                              <VpnKeyIcon className={classes.blueIcon} />
                              <Typography className={classes.resetText}>
                                {i18n.t('RESET_PASSWORD_KEY')}
                              </Typography>
                            </Button>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </>
                )}
              </Grid>
              <Grid
                container
                justify="flex-end"
                className={clsx(classes.buttons, {
                  [classes.buttonsModal]: modalVersion,
                })}
              >
                <Button
                  id="submit-button"
                  isLoading={isLoading}
                  onClick={submitForm}
                  submitButton
                >
                  {i18n.t('SAVE_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={onCancel}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            </>
          )}
        </Formik>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { data },
  companies: { companyList, isLoading },
  errors: { fieldsErrors },
  operators: { checks },
}: ApplicationState) => ({
  fieldsErrors,
  companyList: companyList.results,
  operator_uuid: data?.operator_uuid,
  companyLoading: isLoading,
  checks,
  permissions: data?.permissions,
});

export default connect(mapStateToProps, {
  modalOpen,
  modalClose,
  clearFieldsErrors,
  resetMFAToOperatorRequest,
  toggleBlockOperatorRequest,
  updateMFARequest,
  setPendingPermissionsRequest,
})(FormOperator);
